export default __webpack_public_path__ + "static/media/impact-logo.b06623d7.svg";